(function () {
    "use strict";

    angular.module("app").directive("habilRelativeMaxDate", RelativeMaxDateDirective);

    function RelativeMaxDateDirective() {
        return {
            restrict: "A",
            link: SetMax
        };
    }

    function SetMax(_scope, element, attr) {
        const relativeDate = attr.habilRelativeMaxDate;

        if (!relativeDate)
            return;

        const nativeElement = element[0];
        if (!isDateInput(nativeElement))
            return;

        const maxDate = calculateMaxDate(relativeDate.trim());

        if (maxDate === null)
            return;

        nativeElement.max = maxDate.toISOString().split("T")[0];

        function isDateInput(element) {
            if (!(element instanceof HTMLInputElement))
                return false;

            return element.type === 'date';
        }

        function calculateMaxDate(relativeDate) {
            
            // Calculate the offset in years
            const offset = parseInt(relativeDate);

            if (isNaN(offset))
                return null;

            const maxDate = new Date();

            const actualYear = maxDate.getFullYear() + offset;

            maxDate.setFullYear(actualYear);

            return maxDate;
        }
    }
})();